import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center"
  },
  numberInput: {
    flex: 1,
    backgroundColor: "#f1f1f1",
    borderWidth: 1,
    borderColor: "#ccc"
  },
  token_header_container: {
    paddingHorizontal: "10%",
    marginTop: 25,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "80%"
  },
  token_header: {
    alignItems: "center",
    justifyContent: "center",
    marginRight: 15,
  },
  token_header_image: {
    width: 65,
    height: 65,
    borderRadius: 65,
    borderWidth: 3,
    borderColor: "#32BFB1",
    borderRadius: 50
  },
  token_header_title: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#2C2C2E",
    marginBottom: 5
  },
  token_header_info: {
    fontSize: 12,
    color: "#666",
  },
  token_header_value: {
    fontWeight: "bold",
    color: "#32BFB1",
    fontSize: 22,
    marginTop: -6

  },
  token_info_container: {
    marginTop: 20,
    paddingHorizontal: "10%",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  token_info: {
    alignItems: "center",
  },
  token_info_title: {
    fontSize: 10,
    textTransform: "uppercase",
  },
  token_percent_value: {
    fontSize: 10,
    color: "#32BFB1",
  },
  token_default_info_value: {
    fontSize: 10,
    color: "#2C2C2E",
    opacity: 0.7,
  },
  hl: {
    height: 2,
    width: "90%",
    marginTop: 10,
    marginLeft: "5%",
    backgroundColor: "#2C2C2E",
    opacity: 0.5,
    paddingHorizontal: "10%",
  },
  hr: {
    height: 2,
    // width: "90%",
    marginTop: 10,
    // marginLeft: "5%",
    backgroundColor: "#2C2C2E",
    opacity: 0.5,
    // paddingHorizontal: "10%",
  },
  balance_info_container: {
    // flex: 1,
    flexDirection: "row",
    paddingHorizontal: "10%",
    marginTop: 25,
    justifyContent: "space-between",
  },
  balance_info_title: {
    fontSize: 12,
    fontWeight: "bold",
  },
  balance_info_value: {
    fontSize: 11,
    color: "#2C2C2E",
    opacity: 0.7,
  },
  action_buttons_container: {
    width: "100%",
    marginTop: 20,
    marginHorizontal: "auto",
    paddingHorizontal: 25,
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20
  },
  action_button: {
    padding: 10,
    borderRadius: 20,
  },
  action_button_text: {
    textTransform: "uppercase",
    fontWeight: "bold",
    color: "#FFF",
    textAlign: 'center'
  },
  contentPageTab: {
    paddingHorizontal: 25
  },
  contentPurchase: {
    paddingHorizontal: 25,
    marginTop: 20
  },
  titlePurchase: {
    textAlign: 'center',
    marginBottom: 20
  },
  contentPurchaseAmount: {
    paddingHorizontal: 20,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  contentOrders: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  orderPurchases: {
    fontSize: 12
  },
  orderPurchasesBold: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  orderSale: {
    fontSize: 12
  },
  orderSaleBold: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  contentDescriptionOrders: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 5
  },
  textDescriptionsOrders: {
    fontSize: 12,
    width: "40%"
  },
  actionsOrders: {
    fontSize: 12,
    width: "20%"
  },
  contentPurchaseOrSale: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  amountPurchase: {
    fontSize: 12
  },
  pricePurchase: {
    fontSize: 12,
    color: 'green'
  },
  amountSale: {
    fontSize: 12
  },
  priceSale: {
    fontSize: 12,
    color: '#B90000'
  },
  contentInfoGraphic: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  titleInfoGraphic: {
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 10
  },
  infoGraphic: {
    color: 'rgba(44, 44, 46, 0.5)',
    fontSize: 10,
    marginTop: 10
  },
  dropdown: {
    // width: '85%',
    height: 30,
  },
  numberInput: {
    flex: 1,
    backgroundColor: "#f1f1f1",
    borderWidth: 1,
    borderColor: "#ccc"
  },
  switch: {
    flex: 1,
    backgroundColor: "#e1e1e1",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 15,
    marginTop: 24,
  },
  textEnabled: {
    color: "#222"
  },
  textDisabled: {
    color: "#666"
  },
  priceInput: {
    fontSize: 22,
    textAlign: "center",
    borderBottomWidth: 1,
    flex: 1,
    paddingVertical: 5,
    marginHorizontal: 10
  },
  percentageButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    paddingHorizontal: 15
  },
  percentageButton: {
    borderWidth: 1,
    flex: 1,
    margin: 10,
    padding: 10,
    borderRadius: 4
  },
  percentageButtonText: {
    textAlign: "center"
  }
});

export default styles;
